import { parseYoutubeChannel } from '../../youtube/parsers/channel';
import { parseCatalogChannelBase } from '../../../parsers';
const mergeResponse = (channel, youtube) => (Object.assign(Object.assign({}, channel), _.omit(youtube, 'id', 'title', 'description')));
export const parseChannel = (channel) => {
    const youtubeData = channel.youtube_data;
    const parsedChannel = parseCatalogChannelBase(_.omit(channel, 'youtube_data'));
    if (youtubeData) {
        const parsedYoutubeItem = parseYoutubeChannel(parsedChannel.urlType, youtubeData);
        return mergeResponse(parsedChannel, parsedYoutubeItem);
    }
    return parsedChannel;
};
//# sourceMappingURL=channel.js.map